import { createApp } from 'vue'
import App from './App.vue'
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import PrimeVue from 'primevue/config';
import router from "./router/route.js";
import i18n from './plugins/i18n';
// import VueTelInput from 'vue3-tel-input';
// import 'vue3-tel-input/dist/vue3-tel-input.css';

// import vue3GoogleLogin from 'vue3-google-login';
// import AppleAuth from './plugins/appleAuth';
// import FacebookAuth from './plugins/facebookAuth';
import { createHead } from '@vueuse/head'
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";

// import './registerServiceWorker'

loadFonts();
const head = createHead()
async function bootstrapApp() {
    const config = getConfigDataFromLocalStorage();
    const data = config?.payload?.portal_configuration;
  
    if (!data) return;
  
    // 1. Set favicon dynamically
    const existingFavicon = document.querySelector("link[rel~='icon']");
    if (existingFavicon) {
      existingFavicon.href = data.favicon;
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.rel = "icon";
      faviconLink.href = data.favicon;
      document.head.appendChild(faviconLink);
    }
  
    // 2. Create manifest dynamically
    const manifest = {
      name: data.portal_name,
      short_name: data.portal_name,
      start_url: window.location.origin + "/",
      id: window.location.origin + "/",
      display: "standalone",
      background_color: "#ffffff",
      theme_color: "#26225E",
      icons: [
        {
          src: data.favicon,
          sizes: "192x192",
          type: "image/png",
          purpose: "any"
        },
        {
          src: data.maskableIcon || data.favicon,
          sizes: "512x512",
          type: "image/png",
          purpose: "maskable"
        }
      ]
    };
  
    const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
  
    const existingManifest = document.querySelector('link[rel="manifest"]');
    if (existingManifest) {
      existingManifest.href = manifestURL;
    } else {
      const manifestLink = document.createElement("link");
      manifestLink.rel = "manifest";
      manifestLink.href = manifestURL;
      document.head.appendChild(manifestLink);
    }
  }  
createApp(App)
.use(router)
.use(head)
.use(vuetify)
.use(PrimeVue)
.use(i18n)
// .use(VueTelInput)
// .use(vue3GoogleLogin, {
//     clientId: 'YOUR_GOOGLE_CLIENT_ID'
// })
// .use(AppleAuth, {
//     clientId: 'com.yourapp.identifier',
//     redirectUri: 'https://yourapp.com/callback',
// })
// .use(FacebookAuth, {
//     clientId: 'your-facebook-app-id',
//     redirectUri: 'https://yourapp.com/callback',
//   })
// const config = getConfigDataFromLocalStorage();
// let data = config.payload.portal_configuration;

.mount('#app')
bootstrapApp()